var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isTextObjects
        ? _c(
            "div",
            { staticClass: "layout-sidebar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "layout-sidebar-section-title",
                  on: {
                    click: function ($event) {
                      return _vm.$emit(
                        "toggleSection",
                        "strokeAndBackgroundSection"
                      )
                    },
                  },
                },
                [
                  _c("strong", [_vm._v("Background & Stroke")]),
                  _vm._v(" "),
                  _c("b-icon", {
                    attrs: {
                      icon: _vm.isOpen.strokeAndBackgroundSection
                        ? "chevron-up"
                        : "chevron-down",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                [
                  _c(
                    "b-collapse",
                    {
                      attrs: { visible: _vm.isOpen.strokeAndBackgroundSection },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          [
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v("\n              Group:\n            "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Background",
                                  "label-cols": "4",
                                },
                              },
                              [
                                _c("ColorPicker", {
                                  attrs: {
                                    value: _vm.bgColor,
                                    themes: _vm.themes,
                                    copy: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onChange("bgColor", $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              { attrs: { label: "Stroke", "label-cols": "4" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex" },
                                  [
                                    _c("ColorPicker", {
                                      attrs: {
                                        value: _vm.strokeColor,
                                        themes: _vm.themes,
                                        copy: "",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onChange(
                                            "strokeColor",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        attrs: {
                                          variant: "primary",
                                          size: "sm",
                                          title: "Use background color",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onChange(
                                              "strokeColor",
                                              _vm.target.fill
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "back" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Stroke width",
                                  disabled: _vm.target.locked,
                                },
                              },
                              [
                                _c(
                                  "b-input-group",
                                  {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function () {
                                            return [
                                              _c("b-input", {
                                                attrs: {
                                                  value: _vm.strokeWidth,
                                                  min: 0,
                                                  max: _vm.maxStrokeWidth,
                                                  type: "number",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.onChange(
                                                      "thickness",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1214819521
                                    ),
                                  },
                                  [
                                    _c("b-input", {
                                      attrs: {
                                        value: _vm.strokeWidth,
                                        min: 0,
                                        max: _vm.maxStrokeWidth,
                                        type: "range",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.onChange(
                                            "thickness",
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PositionAndSize", {
        attrs: {
          h: _vm.target.height * _vm.target.scaleY,
          w: _vm.target.width * _vm.target.scaleX,
          x: _vm.target.left,
          y: _vm.target.top,
          "is-open": _vm.isOpen,
        },
        on: { toggleSection: _vm.toggleSectionHandler, input: _vm.onChange },
      }),
      _vm._v(" "),
      _vm.isTextObjects
        ? _c(
            "div",
            { staticClass: "layout-sidebar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "layout-sidebar-section-title",
                  on: {
                    click: function ($event) {
                      return _vm.$emit(
                        "toggleSection",
                        "alignmentAndOpacitySection"
                      )
                    },
                  },
                },
                [
                  _c("strong", [_vm._v("Alignment & Opacity")]),
                  _vm._v(" "),
                  _c("b-icon", {
                    attrs: {
                      icon: _vm.isOpen.alignmentAndOpacitySection
                        ? "chevron-up"
                        : "chevron-down",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                [
                  _c(
                    "b-collapse",
                    {
                      attrs: { visible: _vm.isOpen.alignmentAndOpacitySection },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-row",
                            { staticClass: "mt-2" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Alignment" } },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          value: _vm.textAlign,
                                          options: _vm.alignments,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onChange(
                                              "textAlignment",
                                              $event
                                            )
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "first",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { disabled: "" },
                                                      domProps: { value: null },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.textAlign ===
                                                              null
                                                              ? "Mixed alignment"
                                                              : "Select alignment"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2272855222
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Size" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          value: _vm.fontSize,
                                          type: "number",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onChange(
                                              "fontSize",
                                              $event
                                            )
                                          },
                                          dblclick: _vm.selectValueOnDblclick,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Opacity" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          value: _vm.opacity,
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                          max: "1",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onChange(
                                              "opacity",
                                              $event
                                            )
                                          },
                                          dblclick: _vm.selectValueOnDblclick,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isTextObjects
        ? _c(
            "div",
            { staticClass: "layout-sidebar-section" },
            [
              _c(
                "div",
                {
                  staticClass: "layout-sidebar-section-title",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("toggleSection", "textSettingsSection")
                    },
                  },
                },
                [
                  _c("strong", [_vm._v("Text Settings")]),
                  _vm._v(" "),
                  _c("b-icon", {
                    attrs: {
                      icon: _vm.isOpen.textSettingsSection
                        ? "chevron-up"
                        : "chevron-down",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                [
                  _c(
                    "b-collapse",
                    { attrs: { visible: _vm.isOpen.textSettingsSection } },
                    [
                      _c(
                        "div",
                        [
                          _vm.themeStyles
                            ? _c(
                                "b-form-group",
                                { attrs: { label: "Text Style" } },
                                [
                                  _c("Multiselect", {
                                    attrs: {
                                      placeholder: "Select style",
                                      "track-by": "id",
                                      label: "name",
                                      options: _vm.groupedThemeStyles,
                                      "group-label": "name",
                                      "group-values": "children",
                                      "group-select": false,
                                      multi: false,
                                      "allow-empty": false,
                                      "select-label": "",
                                      "deselect-label": "",
                                    },
                                    on: { input: _vm.applyTextStyle },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "option",
                                          fn: function (props) {
                                            return [
                                              !props.option.$isLabel
                                                ? _c(
                                                    "span",
                                                    {
                                                      style:
                                                        _vm.getStylePreview(
                                                          props.option
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getStyleOptionName(
                                                            props.option
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "themes-group-label",
                                                      style:
                                                        _vm.getStylePreview(
                                                          props.option
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option
                                                            .$groupLabel
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "singleLabel",
                                          fn: function (props) {
                                            return [
                                              props.option.$isLabel
                                                ? _c(
                                                    "span",
                                                    {
                                                      style: {
                                                        fontWeight: "bold",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option
                                                            .$groupLabel
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      style:
                                                        _vm.getStylePreview(
                                                          props.option
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getStyleOptionName(
                                                            props.option
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2593590255
                                    ),
                                    model: {
                                      value: _vm.selectedStyle,
                                      callback: function ($$v) {
                                        _vm.selectedStyle = $$v
                                      },
                                      expression: "selectedStyle",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.options.fontSelector
                            ? _c(
                                "b-form-group",
                                { attrs: { label: "Font" } },
                                [
                                  _c("Multiselect", {
                                    attrs: {
                                      placeholder:
                                        _vm.fontFamily === null
                                          ? "Mixed fonts"
                                          : "Font",
                                      "track-by": "value",
                                      label: "name",
                                      options: _vm.getFonts,
                                      "allow-empty": true,
                                    },
                                    on: { select: _vm.handleFontChange },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "option",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  class: {
                                                    "font-used-in-theme":
                                                      _vm.fontsUsedInStyles.includes(
                                                        props.option.value
                                                      ),
                                                    "theme-font-separator":
                                                      props.option.isLastUsed,
                                                  },
                                                  style: {
                                                    fontFamily:
                                                      props.option.value,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        props.option.name
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "singleLabel",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  style: {
                                                    fontFamily:
                                                      props.option.value,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.option.name)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      168950865
                                    ),
                                    model: {
                                      value: _vm.fontVal,
                                      callback: function ($$v) {
                                        _vm.fontVal = $$v
                                      },
                                      expression: "fontVal",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-form-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Size",
                                        disabled: _vm.target.locked,
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          value: _vm.fontSize,
                                          placeholder:
                                            _vm.fontSize === null
                                              ? "Mixed"
                                              : "",
                                          type: "number",
                                          min: "0",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onChange(
                                              "fontSize",
                                              $event
                                            )
                                          },
                                          dblclick: _vm.selectValueOnDblclick,
                                          keypress: _vm.preventNegativeInput,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Opacity" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          value: _vm.opacity,
                                          placeholder:
                                            _vm.opacity === null ? "Mixed" : "",
                                          type: "number",
                                          min: "0",
                                          step: "0.01",
                                          max: "1",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onChange(
                                              "opacity",
                                              $event
                                            )
                                          },
                                          dblclick: _vm.selectValueOnDblclick,
                                          keypress: _vm.preventNegativeInput,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "actionSection")
                },
              },
            },
            [
              _c("strong", [_vm._v("Actions")]),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.actionSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.actionSection } },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "group-actions-toolbar" },
                      [
                        _c(
                          "b-btn",
                          {
                            attrs: { variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onChange(
                                  _vm.isCustomGroup ? "ungroup" : "group",
                                  null
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.isCustomGroup ? "Ungroup" : "Group"
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                value: "Center to template size",
                                expression: "'Center to template size'",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "custom-group-action",
                            on: {
                              click: function ($event) {
                                return _vm.onChangeWrapped("center", $event)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/center-image.svg",
                                alt: "center-icon",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                value: "Center horizontally",
                                expression: "'Center horizontally'",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "custom-group-action",
                            on: {
                              click: function ($event) {
                                return _vm.onChangeWrapped(
                                  "centerHorizontally",
                                  $event
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/align-center.png",
                                alt: "center-icon-horizontally",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                value: "Center vertically",
                                expression: "'Center vertically'",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "custom-group-action",
                            on: {
                              click: function ($event) {
                                return _vm.onChangeWrapped(
                                  "centerVertically",
                                  $event
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icons/vertical-alignment.png",
                                alt: "center-icon-vertically",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("SelectAllObjectsButton", {
                          attrs: { icon: false, svg: true },
                          on: {
                            unselected: function ($event) {
                              return _vm.$emit("unselected")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.isTextObjects
                          ? [
                              _c("ColorPicker", {
                                attrs: {
                                  value: _vm.fontColor,
                                  themes: _vm.themes,
                                  position: "top-start",
                                  copy: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.onChange("fontColor", $event)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "DropdownCounter",
                                {
                                  staticClass: "group-action-dropdown",
                                  attrs: {
                                    value: _vm.charSpacing,
                                    title: "Text Spacing",
                                    step: 10,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onChange("textSpacing", $event)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "glyphicon glyphicon-text-width",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "LineHeightDropdown",
                                {
                                  staticClass: "group-action-dropdown",
                                  attrs: { value: _vm.lineHeight },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onChange("textLeading", $event)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "cil-line-spacing" })]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "position-fixed apply-to-all-text-dropdwon-section",
                      },
                      [
                        _vm.isTextObjects
                          ? _c("ApplyToAllTextDropdown", {
                              attrs: {
                                options: _vm.options,
                                target: _vm.target,
                              },
                            })
                          : _c("ApplyToAllImageDropdown", {
                              staticClass: "mt-3",
                              attrs: { target: _vm.target },
                            }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "w-100",
          attrs: { variant: "danger" },
          on: { click: _vm.handleDelete },
        },
        [
          _c("b-icon", { attrs: { icon: "trash" } }),
          _vm._v("\n    Delete Selected Fields\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }